import countryMap from '@client/utils/countryMap'
import { brStates, usStates } from '@client/utils/statesMap'

const countryFullName = country => {
  return countryMap[country]
}

const getBRAddress = (country, data) => {
  const brStateInitials = Object.keys(brStates).find(
    state => brStates[state] === data.state
  )
  return `${data.streetAddress}, ${data.streetNumber}, ${data.complement} - ${
    data.district
  }, ${data.city} - ${brStateInitials}, ${data.zip}, ${countryFullName(
    country
  )}`
}

const getUSAddress = (country, data) => {
  const usStateInitials = usStates[data.state]

  return `${data.streetNumber}, ${data.streetAddress}, ${data.complement}, ${
    data.city
  } - ${usStateInitials}, ${data.zip}, ${countryFullName(country)}`
}

const getFullAddress = (country, data) => {
  switch (country) {
    case 'br':
      return getBRAddress(country, data)
    case 'us':
      return getUSAddress(country, data)
    default:
      return null
  }
}

export default getFullAddress
